module.exports = __webpack_public_path__ + "img/12@2x.e3d3d2f2.png";